"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _partial = _interopRequireDefault(require("react-utils/partial"));

var _default = {
  partial: _partial.default
};
exports.default = _default;
module.exports = exports.default;